<template>
  <div>
    <div class="header">
      <div class="w1200 clearfix">
        <div class="header_l">
          <div style="float:left;margin-right:10px;"><img src="../../assets/led/clogo.png" width="25px" style="vertical-align: middle;"></div>
          欢迎光临志鹏供应链<em><img src="../../assets/led/zp_01.png"> 400-040-7890</em>
        </div>
        <div class="header_r">
          <a href="javascript:;" class="ewm_btn">手机版<em><img src="../../assets/images/qr000.png"></em></a>
          <em v-if="!current_user.id">
            <router-link :to="{path:'/Login',query: {return_url: return_url}}" class="login_btn">登录</router-link>
            <router-link :to="{path:'/Register'}" class="register_btn">注册</router-link>
          </em>
          <em v-else>
            <router-link :to="{path:'/MyOrder'}" class="wddd_btn">我的订单</router-link>
            <a href="javascript:;" class="login_btn" @click="logout">退出</a>
            <router-link :to="{path:'/PersonalData'}" style="color:#fff;">欢迎-{{current_user.name || current_user.tel}}</router-link>
          </em>
        </div>
      </div>
    </div>
    <div class="hxq_ppsp">
      <img src="../../assets/led/led_introduce_000.png"  width="100%"/>
      <div class="hxq_fllb_sx">
        <img src="../../assets/led/led_l_1.png" height="290px;" style="float:left;"/>
        <div class="led_font">
          <span class="led_font_span1"></span>
          <span class="led_font_span2"></span>
          <span class="led_font_span3"></span>
          <span class="led_font_span4"></span>
          <p>一个仓库，物资品种成千上万，限于人力物力，</p>
          <p>不可能都实行同等程度的精心管理，</p>
          <p>也没有必要，应当实行重点管理。</p>
          <p>有必要对企业的库存进行分类，</p>
          <p>以便对不同的库存物品实施不同的库存管理方法。</p>
        </div>
      </div>
      <div class="hxq_fllb_sx">
        <img src="../../assets/led/led_l_2.png" height="290px;" style="float:left;"/>
        <div class="led_font">
          <span class="led_font_span1"></span>
          <span class="led_font_span2"></span>
          <span class="led_font_span3"></span>
          <span class="led_font_span4"></span>
          <p>按照储存物资种类的多少分类</p>
          <p>根据技术与保管方式分类</p>
          <p>根据位置分类</p>
          <p>根据结构和构造分类</p>
          <p>根据用途分类</p>
          <p>根据仓库功能分类</p>
          <p>根据营运形态分类</p>
        </div>
      </div>
      <div class="hxq_fllb_sx">
        <img src="../../assets/led/led_l_3.png" height="290px;" style="float:left;"/>
        <div class="led_font">
          <span class="led_font_span1"></span>
          <span class="led_font_span2"></span>
          <span class="led_font_span3"></span>
          <span class="led_font_span4"></span>
          <p>通过创建相对应的电子仓库，录入物料信息</p>
          <p>库存信息等，标准化库存位置和存放规则</p>
          <p>确保一物一码，一码一位</p>
          <p>保证库存位置的准确性。</p>
          <p>根据物料位置的信息结合可视化视图，</p>
          <p>管理人员可以快速、准确的对物料进行定位</p>
        </div>
      </div>
      <div class="hxq_fllb_sx">
        <img src="../../assets/led/led_l_4.png" height="250px;" style="float:left;"/>
        <div class="led_font">
          <span class="led_font_span1"></span>
          <span class="led_font_span2"></span>
          <span class="led_font_span3"></span>
          <span class="led_font_span4"></span>
          <p>防止供应断档</p>
          <p>保证生产连续性</p>
          <p>避免销售波动</p>
          <p>展示功能</p>
          <p>储备功能</p>
          <p>提高客户服务水平，保障供应降低库存成本</p>
        </div>
      </div>
      <div class="hxq_fllb_sx">
        <img src="../../assets/led/led_l_5.png" height="250px;" style="margin-top:90px;"/>
        <div class="led_font" style="margin-bottom:60px;">
          <span class="led_font_span1"></span>
          <span class="led_font_span2"></span>
          <span class="led_font_span3"></span>
          <span class="led_font_span4"></span>
          <p>实时库存报告强化管理和控制</p>
          <p>智能结算降低手工作业量</p>
          <p>业务财务一体化管理</p>
          <p>图形可视化，简化繁杂的操作</p>
          <p>自助式分析报表</p>
          <p>多仓共管，掌控物流网络</p>
          <p>自定义存储策略，上架逻辑、拣货逻辑</p>
          <p>安全库存控制</p>
          <p>出仓财务审核控制</p>
          <p>操作与仓管任务协同作业</p>
        </div>
      </div>
      <div class="bottomcall">
        <img src="../../assets/led/bottom.png" style="margin-top:60px;" width="100%"/>
        <!-- <router-link :to="{path:'/Brand'}" target="_blank" class="">在线咨询</router-link> -->
        <div class="lxtext">
          <p>联系我们</p>
          <p>400-040-7890</p>
          <p>0471-6922123</p>
          <p>0471-6928123</p>
          <p>0471-5291118</p>
          <p>0471-5291119</p>
        </div>
      </div>
      <div class="back_home">
        <router-link :to="{path:'/'}">
          <img src="../../assets/led/back_home.png" height="90px;"/>
        </router-link>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Footer from '@/components/Footer'
export default {
  name: 'LedIntroduce',
  components: { Footer },
  data () {
    return {
      return_url: this.$route.fullPath
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {

  },
  methods: {
    async logout () {
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>
<style scoped>
.bottomcall{
  position: relative;
}
.lxtext{
  position: absolute;
  top: 85px;
  right: 420px;
  line-height: 25px;
  color: #fff;
  letter-spacing: 4px;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
.back_home{
  position: fixed;
  bottom: 60px;
  right: 60px;
  -webkit-box-shadow: 0 0 20px #999999;
  transform: translate(0, -10px);
  border-radius: 45px;
  height: 90px;
}
.hxq_fllb_sx{
  width: 66%;
  margin: 0 auto;
  margin-top: 50px;
  overflow: hidden;
}
.hxq_fllb_sx img{
  transition: 0.6s;
}
.hxq_fllb_sx img:hover{
  transform:scale(1.1);
}
.led_font{
  float: left;
  letter-spacing:4px;
  width:500px;
  font-size: 18px;
  font-weight: bold;
  line-height: 25px;
  margin-left: 260px;
  border: 2px solid #858282;
  text-align: center;
  position: relative;
  padding: 35px;
}
.hxq_ppsp .hxq_fllb_sx:nth-child(odd) .led_font {
  float: right;
  margin-left: 0;
  margin-top: 20px;
}
.hxq_ppsp .hxq_fllb_sx:nth-child(odd) > img{
  float: left !important;
}
.hxq_ppsp .hxq_fllb_sx:nth-child(even) .led_font {
  float: left;
  margin-left: 0;
  margin-top: 45px;
}
.hxq_ppsp .hxq_fllb_sx:nth-child(even) > img{
  float: right !important;
}
.led_font span{
  position: absolute;
  transition: all 1s;
}
.led_font span.led_font_span1{
  width: 3px;
  height: 0;
  left: -2px;
  top: -1px;
  z-index: 2;
  background: #3b62e2;
}
.led_font:hover span.led_font_span1{
  height: 101%;
}
.led_font span.led_font_span2{
  width: 0;
  height: 3px;
  left: -1px;
  bottom: -2px;
  z-index: 2;
  background: #3b62e2;
}
.led_font:hover span.led_font_span2{
  width: 573px;
}
.led_font span.led_font_span3{
  width: 3px;
  height: 0;
  right: -2px;
  top: -1px;
  z-index: 2;
  background: #3b62e2;
}
.led_font:hover span.led_font_span3{
  height: 101%;
}
.led_font span.led_font_span4{
  width: 0;
  height: 3px;
  right: -1px;
  top: -2px;
  z-index: 2;
  background: #3b62e2;
}
.led_font:hover span.led_font_span4{
  width: 573px;
}
.hxq_ppsp{
  position: relative;
  top: 41px;
}
.header_l{
  color:#fff;
}
.header_l em{
  color: #fe722c;
}
.header_r a.wddd_btn:hover{
  color:#0f6efd;
}
.header_r a.login_btn:hover{
  color:#0f6efd;
}
.header_r a.ewm_btn:hover{
  color:#0f6efd;
}
.header{
  position: fixed;
  right: 0;
  left: 0;
  background: #29293e;
}
.header_r a{
  color:#b5b5b5;
}
</style>



// WEBPACK FOOTER //
// src/view/led/led_introduce.vue